import script from "./Author-item.vue?vue&type=script&setup=true&lang=js"
export * from "./Author-item.vue?vue&type=script&setup=true&lang=js"

import "./Author-item.vue?vue&type=style&index=0&id=e3bb7fbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3bb7fbe"]])

export default __exports__